import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';
import { sanitizeFileName } from '../../utils/Utils';

export const uploadFile = async (formData, onUploadProgress) => {
  const response = await axios.postRequest(`/tpo/uploadxls`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  });
  return response;
};

export const fetchRecentlyUploadData = async (market, pageNo = 1, pageSize = 5) => {
  try {
    const response = await axios.getRequest(
      `/tpo/FileUploadStatus/${encodeURIComponent(market)}?pageNo=${0}&pageSize=${1000}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchRecentlyUploadDataStatusCheck = async (uploadIDs) => {
  try {
    const response = await axios.getRequest(`/tpo/getCurrentStatus?uploadIds=${uploadIDs}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const deleteUploadedData = async (typeOfData, uploadId, fileName) => {
  try {
    const response = await axios.deleteRequest(
      `/tpo/deleteFile/${typeOfData}?uploadId=${uploadId}&fileName=${fileName}`
    );
    const successMessage = response?.message || 'File deleted successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to delete data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const downloadUploadedFile = async (uploadId, fileName) => {
  try {
    const response = await axios.getRequest(`/tpo/downloadFile/${uploadId}?fileName=${fileName}`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });

    const url = window.URL.createObjectURL(
      new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', sanitizeFileName(fileName));
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    const errorMessage = error?.message || 'Failed to download file!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const downloadTemplate = async (market, clickType) => {
  try {
    const response = await axios.getRequest(`/tpo/downloadTemplate/${encodeURIComponent(market)}/${clickType}`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });

    const url = window.URL.createObjectURL(
      new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', sanitizeFileName(clickType));
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    const errorMessage = error?.message || 'Failed to download file!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchFileUploadList = async (selectedBu) => {
  try {
    const response = await axios.getRequest(`/tpo/getFileUploadList?market=${encodeURIComponent(selectedBu)}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
